<div class="wrapper">
  <div class="label-text" translate>{{labelKey}}</div>
  <div class="input-error" [formGroup]="form">
    <input class="input"
           [placeholder]="placeholder"
           [formControlName]="controlName"
           [type]="inputType"
           [tabIndex]="tabulatorIndex"
           [min]="minValue">
    <cc-input-errors
      [form]="form"
      [inputName]="controlName"
      [errors]="errors">
    </cc-input-errors>
  </div>
</div>
